import React from 'react';
import PropTypes from 'prop-types';

import './view.scss';

export const HeadlineView = ({ text }) => (<h3 className="headline">{ text }</h3>);

HeadlineView.propTypes = {
    text: PropTypes.string.isRequired
};